<template>
  <div
    v-if="isItems"
    :id="id"
    :class="
      isPromoFix ? 'sub-block-margin promo-fix promo-title-fix' : 'offers'
    "
  >
    <div class="l-container">
      <component
        :is="viewComponent"
        :white_buttons="white_buttons"
        :data="data"
        @open-modal="openModal"
        @send-analytics="(value) => $emit('sendAnalytics', value)"
      />
    </div>
    <QuickViewOffer
      v-if="quickViewOfferData"
      :model="quickViewOfferData"
      :@order="openOrderModal"
      @close="quickViewOfferData = null"
    />
  </div>
</template>

<script setup lang="ts">
import Carousel from './carousel/Carousel.vue';
import Custom from './custom/Custom.vue';

import type {
  OfferListBlock,
  OfferListBlockContentItems,
} from '@/interfaces/constructor';
import { useModalsStore } from '~/stores/modals';

const QuickViewOffer = defineAsyncComponent(
  () => import('~/components/modals/quick-view-offer/quick-view-offer.vue')
);

const modalsStore = useModalsStore();
const quickViewOfferData = ref<OfferListBlockContentItems | null>(null);
const viewComponent = computed(() =>
  props.data.layout === 'custom' ? Custom : Carousel
);
defineEmits(['sendAnalytics']);
const props = defineProps({
  data: {
    type: Object as () => OfferListBlock,
    required: true,
  },
  white_buttons: {
    type: Boolean,
    default: false,
  },
});

function openModal(model: OfferListBlockContentItems) {
  quickViewOfferData.value = model;
}

const openOrderModal = () => {
  modalsStore.setData({
    name: 'order',
    data: {
      offer: quickViewOfferData.value,
      position: 1,
      blockType: 'pu-offer',
    },
  });
  quickViewOfferData.value = null;
};

const isItems = computed(() => props.data?.items && props.data.items.length);

const isPromoFix = computed(() => !!props.data?.isPromoFix);

const id = computed(() => (isItems.value ? props.data?.id : '0'));
</script>
<style lang="scss" src="./OfferListScss.scss"></style>
